import { apiService } from '../../..'
import {
  ConfirmAccessRequest,
  ConfirmAccessResponseBody,
  AuthorizeRequest,
  AuthorizeResponseBody,
  DeletePermissionRequest,
  GetPermissionsResponseBody,
} from '../types'

const baseURL = '/portal/consumers/oauth'

export const oauthService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getPermissions: build.query<GetPermissionsResponseBody, void>({
      query: () => {
        return {
          url: `${baseURL}/permissions`,
          method: 'GET',
        }
      },
      providesTags: ['Permissions'],
    }),
    deletePermission: build.mutation<void, DeletePermissionRequest>({
      query: (req) => {
        return {
          url: `${baseURL}/revoke-permissions/${req.params.clientId}`,
          method: 'DELETE',
        }
      },
      invalidatesTags: ['Permissions'],
    }),
    confirmAccess: build.query<ConfirmAccessResponseBody, ConfirmAccessRequest>({
      query: (req) => {
        const params = new URLSearchParams({
          clientId: req.params.clientId,
          grantType: req.params.grantType,
          redirectUri: req.params.redirectUri,
        })

        req.params.scopes.forEach((scope) => params.append('scopes', scope))

        return {
          url: `${baseURL}/confirm-access?${params.toString()}`,
          method: 'GET',
        }
      },
    }),
    authorize: build.mutation<AuthorizeResponseBody, AuthorizeRequest>({
      query: (req) => {
        return {
          url: `${baseURL}/authorize`,
          method: 'POST',
          data: req.body,
        }
      },
      invalidatesTags: ['Permissions'],
    }),
  }),
})
